import React, { Component } from "react"
import { connect } from "react-redux"
import styled from "styled-components"
import ReactTable from "react-table"
import "react-table/react-table.css"
import "../../style/react-table-custom.css"

import moment from "moment"
import request from "../../utils/request"
import Pagination from "../../components/paginationTable/pagination"
import Button from "../../components/button"
import TabComponent from "../../components/tabComponent"
import DatePicker from "react-datepicker"

import "./reviewList.css"

const Card = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  border-radius: 5px;
  border: 1px solid ${(props) => props.theme.active};
  background: #fff;
  height: max-content;
  width: 100%;
  position: relative;
  top: -1px;
  padding: 10px;
  align-items: flex-start;
  overflow: auto;
`

const TextCollum = styled.div`
  margin-bottom: 0.5rem;
  font-size: 13px;
  font-weight: 500;
  line-height: 1.2;
  color: inherit;
`

const Overlay = styled.div`
  content: " ";
  z-index: 10;
  display: block;
  position: absolute;
  height: 100%;
  top: 0;
  left: 0;
  right: 0;
  background: rgba(255, 255, 255, 0.8);
`

class ReviewListPage extends Component {
  constructor(props) {
    super(props)

    this.state = {
      // table
      data: [],
      tempDataTable: [],
      loading: false,
      page: 0,
      totalPages: 0,
      totaldata: 0,
      limit: 5000,

      // filters
      start_datetime: new Date(moment().startOf("month").format()),
      end_datetime: new Date(moment().endOf("month").format()),
      // starFilter: Array.isArray(JSON.parse(localStorage.getItem("Review-starFilter-arr"))) && JSON.parse(localStorage.getItem("Review-starFilter-arr")).length > 0
      //   ? JSON.parse(localStorage.getItem("Review-starFilter-arr"))
      //   : ["5", "4", "3", "2", "1"],
      starFilter: ["5", "4", "3", "2", "1"],

      // search
      searchOption: localStorage.getItem("Review-searchOption") || "",
      textSearch: localStorage.getItem("Review-textSearch") || "",

      // UI
      columnWillShow: [],
      showRightbar: false,

      // guard fetch (กัน request ซ้อนแล้ว state โดนทับ)
      checkLastFetchTime: 0,
    }
  }

  async componentDidMount() {
    this.setColumWillShow()
    this.props.setPageTitle("Review List")

    // sync from URL -> state
    const qs = new URLSearchParams(this.props.history.location.search)
    const startDateParam = qs.get("startDate")
    const endDateParam = qs.get("endDate")
    const starsParam = qs.get("stars")
    const searchParam = qs.get("search")
    const byParam = qs.get("by")

    const startDateLocal = localStorage.getItem("Review-startDate")
    const endDateLocal = localStorage.getItem("Review-endDate")

    const nextState = {}

    if (startDateParam) {
      nextState.start_datetime = new Date(startDateParam)
      localStorage.setItem("Review-startDate", startDateParam)
    } else if (startDateLocal) {
      nextState.start_datetime = new Date(startDateLocal)
      qs.set("startDate", startDateLocal)
    }

    if (endDateParam) {
      nextState.end_datetime = new Date(endDateParam)
      localStorage.setItem("Review-endDate", endDateParam)
    } else if (endDateLocal) {
      nextState.end_datetime = new Date(endDateLocal)
      qs.set("endDate", endDateLocal)
    }

    if (starsParam) {
      localStorage.setItem("Review-starFilter-arr", starsParam)
      nextState.starFilter = JSON.parse(starsParam)
    }

    if (byParam !== null) {
      localStorage.setItem("Review-searchOption", byParam)
      nextState.searchOption = byParam
    }

    if (searchParam !== null) {
      localStorage.setItem("Review-textSearch", searchParam)
      nextState.textSearch = searchParam
    }

    this.setState(nextState, () => {
      // ถ้า url ไม่มี start/end เลย -> push default เข้าไป
      const hasStartEnd = !!(startDateParam && endDateParam)
      if (!hasStartEnd) {
        const p = new URLSearchParams(this.props.history.location.search)
        p.set("startDate", moment(this.state.start_datetime).format("YYYY-MM-DD"))
        p.set("endDate", moment(this.state.end_datetime).format("YYYY-MM-DD"))
        localStorage.setItem("Review-startDate", moment(this.state.start_datetime).format("YYYY-MM-DD"))
        localStorage.setItem("Review-endDate", moment(this.state.end_datetime).format("YYYY-MM-DD"))
        if (this.state.starFilter && this.state.starFilter.length > 0) p.set("stars", JSON.stringify(this.state.starFilter))
        if (this.state.textSearch) p.set("search", this.state.textSearch)
        if (this.state.searchOption) p.set("by", this.state.searchOption)

        this.props.history.push({
          pathname: this.props.history.location.pathname,
          search: p.toString(),
        })
      }

      this.getDataReviews({ page: 1 })
    })
  }

  // ---------- columns ----------
  setColumWillShow = () => {
    const columns = [
      {
        Header: () => <TextCollum>Review Date</TextCollum>,
        accessor: "Review_Date",
        minWidth: 120,
        Cell: (row) =>
          row.original.Review_Date && row.original.Review_Date !== "-" ? (
            <Button
              style={{
                border: "1px solid transparent",
                padding: "0px",
                width: "auto",
                background: "none",
                color: "#3e5569",
                userSelect: "text",
              }}
              label={row.original.Review_Date}
              className="copyClipBoard"
              onClick={() => navigator.clipboard.writeText(row.original.Review_Date)}
            />
          ) : (
            <p>-</p>
          ),
      },
      {
        Header: () => <TextCollum>Score</TextCollum>,
        accessor: "Score",
        minWidth: 100,
        Cell: (row) =>
          row.original.Score !== "-" ? (
            <div style={{ whiteSpace: "nowrap" }}>{this.renderStars(row.original.Score)}</div>
          ) : (
            <p>-</p>
          ),
      },
      {
        Header: () => <TextCollum>Review comment</TextCollum>,
        accessor: "Review_Comment",
        minWidth: 300,
        Cell: (row) =>
          row.original.Review_Comment && row.original.Review_Comment !== "-" ? (
            <Button
              style={{
                border: "1px solid transparent",
                padding: "0px",
                width: "auto",
                background: "none",
                color: "#3e5569",
                userSelect: "text",
                textAlign: "left",
              }}
              label={row.original.Review_Comment}
              title={row.original.Review_Comment}
              className="copyClipBoard"
              onClick={() => navigator.clipboard.writeText(row.original.Review_Comment)}
            />
          ) : (
            <p>-</p>
          ),
      },
      {
        Header: () => <TextCollum>Maid ID</TextCollum>,
        accessor: "Maid_ID",
        minWidth: 70,
        Cell: (row) =>
          row.original.Maid_ID && row.original.Maid_ID !== "-" ? (
            <Button
              style={{
                border: "1px solid transparent",
                padding: "0px",
                width: "auto",
                background: "none",
                color: "#3e5569",
                userSelect: "text",
              }}
              label={row.original.Maid_ID}
              className="copyClipBoard"
              onClick={() => navigator.clipboard.writeText(String(row.original.Maid_ID))}
            />
          ) : (
            <p>-</p>
          ),
      },
      { Header: () => <TextCollum>Maid Name</TextCollum>, accessor: "Maid_Name", minWidth: 150 },
      {
        Header: () => <TextCollum>Order ID</TextCollum>,
        accessor: "original_id",
        minWidth: 150,
        Cell: (row) =>
          row.original.external_id && row.original.external_id !== "-" ? (
            <Button
              style={{
                border: "1px solid transparent",
                padding: "0px",
                width: "auto",
                background: "none",
                color: "#3e5569",
                userSelect: "text",
              }}
              label={row.original.external_id}
              className="copyClipBoard"
              onClick={() => navigator.clipboard.writeText(String(row.original.external_id))}
            />
          ) : (
            <p>-</p>
          ),
      },
      {
        Header: () => <TextCollum>User ID</TextCollum>,
        accessor: "User_ID",
        minWidth: 70,
        Cell: (row) =>
          row.original.User_ID && row.original.User_ID !== "-" ? (
            <Button
              style={{
                border: "1px solid transparent",
                padding: "0px",
                width: "auto",
                background: "none",
                color: "#3e5569",
                userSelect: "text",
              }}
              label={row.original.User_ID}
              className="copyClipBoard"
              onClick={() => navigator.clipboard.writeText(String(row.original.User_ID))}
            />
          ) : (
            <p>-</p>
          ),
      },
      { Header: () => <TextCollum>User Name</TextCollum>, accessor: "User_Name", minWidth: 150 },
      {
        Header: () => <TextCollum>Booking Date/time</TextCollum>,
        accessor: "Booking_DateTime",
        minWidth: 150,
      },
      { Header: () => <TextCollum>Booking type</TextCollum>, accessor: "Booking_Type", minWidth: 95 },
      { Header: () => <TextCollum>Duration</TextCollum>, accessor: "Duration", minWidth: 75 },
      { Header: () => <TextCollum>Accommodation</TextCollum>, accessor: "Accommodation_Type", minWidth: 170 },
    ]

    this.setState({ columnWillShow: columns })
  }

  renderStars(score) {
    const s = Math.max(0, Math.min(5, Number(score || 0)))
    const full = "★".repeat(s)
    // const empty = "☆".repeat(5 - s)
    return (
      <span>
        <span>{full}</span>
        {/* <span style={{ opacity: 0.5 }}>{empty}</span> ({s}) */}
      </span>
    )
  }

  // ---------- helper ----------
  buildFullName = (obj) => {
    if (!obj) return "-"
    const first = obj.first_name || obj.firstName || ""
    const last = obj.last_name || obj.lastName || ""
    const full = `${first} ${last}`.trim()
    return full || "-"
  }

  // ---------- API ----------
  async getDataReviews(pageObj) {
    const page = pageObj && pageObj.page ? pageObj.page : 1
    const { start_datetime, end_datetime, textSearch, searchOption, starFilter, limit } = this.state

    const params = {
      start_date: start_datetime ? moment(start_datetime).format("YYYY-MM-DD") : moment().format("YYYY-MM-DD"),
      end_date: end_datetime ? moment(end_datetime).format("YYYY-MM-DD") : moment().format("YYYY-MM-DD"),
      search: (textSearch || "").trim(),
      by: searchOption || "",
      rating: (starFilter && starFilter.length > 0) ? starFilter.join(",") : "",
      page,
      limit,
    }

    this.setState({ loading: true, data: [], tempDataTable: [] })

    const lastFetchTime = new Date().getTime()
    this.setState({ checkLastFetchTime: lastFetchTime })

    const url =
      `booking/review/list?` +
      `page=${params.page}` +
      `&limit=${params.limit}` +
      `&rating=${params.rating}` +
      `&start_date=${params.start_date}` +
      `&end_date=${params.end_date}` +
      `&search=${encodeURIComponent(params.search)}` +
      `&by=${params.by}`

    try {
      const resp = await request.get(url)
      const data = resp.data

      // กันผลลัพธ์เก่ามาทับ state ล่าสุด
      if (this.state.checkLastFetchTime !== lastFetchTime) return

      // { total, page, limit, total_pages, reviews: [...] }
      const items = data.reviews || []
      const itemCount = data.total || items.length

      const rows = items.map((r) => {
        const bc = r.booking_calendar || {}
        const b = bc.booking || {}

        const bookingDateRaw = r.booking_create_datetime || b.create_datetime || null
        const bookingDate = bookingDateRaw ? moment(bookingDateRaw).format("YYYY-MM-DD") : "-"

        const start = bc.start_datetime ? moment(bc.start_datetime) : null
        const end = bc.end_datetime ? moment(bc.end_datetime) : null
        const bookingDateTime =
          start ? `${start.format("YYYY-MM-DD  HH:mm")}` : "-"

        // rating
        const rawScore = r.rating
        const score = rawScore === null || rawScore === undefined ? "-" : Number(rawScore)

        // ชื่อ user/maid อยู่ใน booking.user และ booking.maid.user
        const userName = this.buildFullName(b.user)
        const maidName = this.buildFullName(b.maid?.user)

        let reviewData = {
          Booking_Date: bookingDate,
          Review_Date: r.create_datetime ? moment(r.create_datetime).format("YYYY-MM-DD") : "-",
          Score: score,
          Review_Comment: r.description && String(r.description).trim() !== "" ? r.description : "-",

          original_id: r.original_id || "-",
          Booking_ID: r.internal_id || "-",
          external_id: r.external_id || "-",
          Maid_ID: b.maid ? b.maid.real_maid_id : "-",
          Maid_Name: maidName,

          User_ID: b.user ? b.user.customer_id : "-",
          User_Name: userName,

          Booking_DateTime: bookingDateTime,

          Duration: b.duration ?? "-",
          Accommodation_Type: b.accommodation || "-",
        }

        const combinedOrderType = `${b.type === "MULTI_PACKAGE"
          ? "MP" + b.multi_times + "x"
          : b.type === "ONE_TIME_AUTO_SELECT"
            ? "OTA"
            : b.type === "ONE_TIME_MANUAL_SELECT"
              ? "OTM"
              : ""
          }${b.duration}${b.bring_equipment ? "E" : ""}${b.service_cleaning && b.service_drapery
            ? "I" //"CI"
            : b.service_drapery
              ? "I"
              : b.service_cleaning
                ? "" //"C"
                : ""
          }`

        reviewData.Booking_Type = combinedOrderType

        return reviewData
      })

      this.setState({
        data: rows,
        tempDataTable: rows,
        loading: false,
        totaldata: itemCount,
        totalPages: Math.ceil(itemCount / limit),
      })
    } catch (err) {
      this.setState({ loading: false, data: [], tempDataTable: [], totaldata: 0, totalPages: 0 })
    }
  }

  // ---------- handlers ----------
  handleChangeStartDate = (e) => {
    if (e === null) e = new Date()
    this.setState({ start_datetime: e, page: 0 }, () => this.pushUrlParamsAndFetch())
  }

  handleChangeEndDate = (e) => {
    if (e === null) e = new Date()
    this.setState({ end_datetime: e, page: 0 }, () => this.pushUrlParamsAndFetch())
  }

  handleChangeStars = (e) => {
    let value = e.target.value
    if (Array.isArray(value) && value.length === 0) {
      value = ["5", "4", "3", "2", "1"]
    }
    localStorage.setItem("Review-starFilter-arr", JSON.stringify(value))
    this.setState({ starFilter: value, page: 0 }, () => this.pushUrlParamsAndFetch())
  }

  onSentSearch = () => {
    localStorage.setItem("Review-textSearch", this.state.textSearch || "")
    this.setState({ page: 0 }, () => this.pushUrlParamsAndFetch())
  }

  pushUrlParamsAndFetch = () => {
    const { start_datetime, end_datetime, starFilter, textSearch, searchOption } = this.state
    const params = new URLSearchParams(this.props.history.location.search)

    params.set("startDate", moment(start_datetime).format("YYYY-MM-DD"))
    params.set("endDate", moment(end_datetime).format("YYYY-MM-DD"))
    localStorage.setItem("Review-startDate", moment(start_datetime).format("YYYY-MM-DD"))
    localStorage.setItem("Review-endDate", moment(end_datetime).format("YYYY-MM-DD"))

    if (starFilter && starFilter.length > 0) params.set("stars", JSON.stringify(starFilter))
    else params.delete("stars")

    if (textSearch) params.set("search", textSearch)
    else params.delete("search")

    if (searchOption) params.set("by", searchOption)
    else params.delete("by")

    this.props.history.push({
      pathname: this.props.history.location.pathname,
      search: params.toString(),
    })

    this.getDataReviews({ page: 1 })
  }

  compareBy(key, order) {
    return function (a, b) {
      // a[key] = a[key] === null || a[key] === undefined ? -Infinity : a[key];
      // b[key] = b[key] === null || b[key] === undefined ? -Infinity : b[key];

      // a[key] = typeof a[key] === "string" ? a[key].toLowerCase() : a[key];
      // b[key] = typeof b[key] === "string" ? b[key].toLowerCase() : b[key];

      if (order) {
        if (a[key] < b[key]) {
          return 1
        }
        if (a[key] > b[key]) {
          return -1
        }
        return 0
      } else {
        if (a[key] > b[key]) {
          return 1
        }
        if (a[key] < b[key]) {
          return -1
        }
        return 0
      }
    }
  }

  async togleSorting(newSorted, column, shiftKey) {
    let arrayCopy =
      (await this.state.tempDataTable.length) > 0
        ? [...this.state.tempDataTable]
        : [...this.state.data]
    await arrayCopy.sort(this.compareBy(column.id, newSorted[0].desc))
    this.setState({ data: arrayCopy, tempDataTable: arrayCopy })
  }

  render() {
    const tabData = [{ label: "Reviews", total: this.state.totaldata, key: "12", path: "/reviews" }]
    const { starFilter } = this.state

    return (
      <div>
        {this.state.showRightbar && <Overlay onClick={() => this.setState({ showRightbar: false })} />}

        <div className="col-md-12" style={{ paddingBottom: "10px" }}>
          <div className="row">
            <div className="col-md-3">
              <div className="col-md-12">
                <label style={{ fontSize: "16px", fontWeight: "500px" }}>Start Date</label>
              </div>
              <div className="col-md-12" style={{ zIndex: 9 }}>
                <DatePicker
                  className="Rectangle-Datepicker-Arrpove"
                  value={this.state.start_datetime}
                  name="start_datetime"
                  selected={this.state.start_datetime}
                  onChange={this.handleChangeStartDate}
                  timeIntervals={15}
                  dateFormat=" yyyy-MM-dd "
                  popperPlacement="bottom"
                />
              </div>
            </div>

            <div className="col-md-3">
              <div className="col-md-12">
                <label style={{ fontSize: "16px", fontWeight: "500px" }}>End Date</label>
              </div>
              <div className="col-md-12" style={{ zIndex: 9 }}>
                <DatePicker
                  className="Rectangle-Datepicker-Arrpove"
                  value={this.state.end_datetime}
                  name="end_datetime"
                  selected={this.state.end_datetime}
                  onChange={this.handleChangeEndDate}
                  timeIntervals={15}
                  dateFormat=" yyyy-MM-dd "
                  popperPlacement="bottom"
                />
              </div>
            </div>

            <div className="col-md-2">
              <div className="col-md-12">
                <label style={{ fontSize: "16px", fontWeight: "500px" }}>Stars</label>
              </div>
              <div className="col-md-12" style={{
                marginTop: 5,
                display: "flex",
                alignItems: "center",
              }}>
                {["5", "4", "3", "2", "1"].map((star) => (
                  <div key={star} style={{
                    marginBottom: 5,
                    whiteSpace: "nowrap",
                    display: "flex",
                    alignItems: "center",
                    marginRight: 15,
                    gap: 5,
                  }}>
                    <input
                      type="checkbox"
                      value={star}
                      checked={starFilter.includes(star)}
                      onChange={(e) => {
                        let newStars = [...starFilter]
                        if (e.target.checked) {
                          newStars.push(star)
                        } else {
                          newStars = newStars.filter((s) => s !== star)
                        }
                        this.handleChangeStars({ target: { value: newStars } })
                      }}
                    />{" "}
                    <div style={{ fontSize: 16 }}
                    >{star}</div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>

        <TabComponent transparent tabData={tabData} />

        <Card className="col-md-12">
          <ReactTable
            data={this.state.tempDataTable.length > 0 ? this.state.tempDataTable : this.state.data}
            columns={this.state.columnWillShow}
            loading={this.state.loading}
            pageSize={25}
            page={this.state.page}
            showPagination={true}
            PaginationComponent={Pagination}
            pages={this.state.totalPages}
            manual
            onPageChange={(page) => this.setState({ page }, () => this.getDataReviews({ page: page + 1 }))}
            getTrProps={() => ({ style: { height: 25, overflow: "hidden" } })}
            className="-striped -highlight bookingLsittetable"
            onSortedChange={(newSorted, column, shiftKey) =>
              this.togleSorting(newSorted, column, shiftKey)
            }
          />
        </Card>
      </div>
    )
  }
}

const mapState = (state) => ({})

const mapDispatch = (dispatch) => {
  return {
    setPageTitle: dispatch.Title.setPageTitle,
  }
}

export default connect(mapState, mapDispatch)(ReviewListPage)
